module.exports = __webpack_public_path__ + "img/占位图_en.3ac9c92e.png";